import { Layout, _decorator } from 'cc';

const { ccclass } = _decorator;

@ccclass('InverseLayout')
export default class InverseLayout extends Layout {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    protected _checkUsefulObj() {
        super._checkUsefulObj();
        this._usefulLayoutObj.reverse();
    }
}
